export const enum TicketingSystemNotification {
    None = 0,
    Email,
    Ticketing
};
